const GET_AZURE_DATABASE_PERFORMANCE_INSIGHT =
  "GET_AZURE_DATABASE_PERFORMANCE_INSIGHT";
const GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_SUCCESS =
  "GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_SUCCESS";
const GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_ERROR =
  "GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_ERROR";

export {
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT,
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_SUCCESS,
  GET_AZURE_DATABASE_PERFORMANCE_INSIGHT_ERROR,
};
